/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { RoleBadgesModule } from '../types'

const elasticsearchRoleBadgesModule: RoleBadgesModule<'elasticsearch'> = {
  allInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.all-elasticsearch-instances',
    defaultMessage: 'This role applies to all current and future Elasticsearch projects.',
  },
  specificInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.elasticsearch',
    defaultMessage:
      'This role applies to {count} Elasticsearch {count, plural, one {project} other {projects}}.',
  },
  customRoleBadgeTooltipMessages: {
    id: 'custom-role-badges.tooltip.elasticsearch',
    defaultMessage:
      'Custom roles are applied to {count} Elasticsearch {count, plural, one {project} other {projects}}.',
  },
  type: 'elasticsearch',
}

export default elasticsearchRoleBadgesModule
